import {Controller} from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
    static targets = [ "switch", "quantity", "label", "submit", "notify", "select" ];

    connect() {
        console.log('tests order connected', this.element)
    }

    toggle(event) {
        const classes = this.switchTarget.classList;
        const current = classes.contains('active');

        if (current) {
            classes.remove('active');
        } else {
            classes.add('active');
        }
        event.stopPropagation();
    }

    // click a radio: close switch pane set toggle to not empty, write label in .selected-prompt
    update_radio(event) {
        const radio = event.target;
        console.log('update radio', radio)
        const classes = this.switchTarget.classList;
        const new_value = Number(radio.value)
        if (new_value === 0) {
            classes.add('empty')
            this.submitTarget.classList.add('hide')
        } else {
            classes.remove('empty')
            this.submitTarget.classList.remove('hide')
            this.labelTarget.innerHTML = new_value
        }
        this.quantityTarget.value = new_value
        this.switchTarget.classList.remove('active')
    }

    update_select(event) {
        const select = event.target
        const new_value = Number($(select).val())
        if (new_value === 0) {
            this.submitTarget.classList.add('hide')
        } else {
            this.submitTarget.classList.remove('hide')
        }
    }
    update_shipping(event) {
        event.stopPropagation()
        const radio = $(event.currentTarget).closest('.radio')
        console.log('update shipping')
        const classes = this.switchTarget.classList
        classes.remove('empty')
        this.labelTarget.innerHTML = $(radio).find('label').text()
        this.switchTarget.classList.remove('active')
        const radio_value = $(radio).find('input').val()
        $('.alternate_address, .suggested_dates').hide()
        if (radio_value === 'alternate_address') {
            console.log('alternate address')
            $('.alternate_address').show()
        }
        if (radio_value === 'pickup') {
            console.log('pickup')
            $('.suggested_dates').show()
        }
        $('#tests-cart .form-actions .submit-btn').attr('disabled', false)
    }


    submit() {
        $(this.submitTarget).find('input[type="submit"]').click(); // submit remote
        // reset quantity, display note
        document.dispatchEvent(new CustomEvent('notify', {detail: {target: this.notifyTarget, msg: 'Das Testmaterial wurde in ihre Bestellliste übernommen.', mode: 'success', position: 'top right'} }));
        $(this.selectTarget).val('').change()
        // make select2 reflect the value change
        const event = new Event('init_select2', {bubbles: true})
        document.dispatchEvent(event)
        this.submitTarget.classList.add('hide')
    }

    submit_box() {
        $(this.submitTarget).find('input[type="submit"]').click(); // submit remote
        document.dispatchEvent(new CustomEvent('notify', {detail: {target: this.notifyTarget, msg: 'Das Testmaterial wurde in ihre Bestellliste übernommen.', mode: 'success', position: 'top right'} }));
    }
}